import React, { useEffect, useState } from 'react';
import {Lang} from '../api/lang';
import { login } from '../api/api';
import { jwtDecode } from 'jwt-decode';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
import { getInitialLang, getStoredLang, setStoredLang } from '../api/langStorage';
import { getStoredRes } from '../api/resStorage';

export default function () {
  const [lang, setLang] = useState(() => getStoredLang());
  const [resolution, setResolution] = useState<string>(() => getStoredRes());
  const [showLoginDialog, setShowLoginDialog] = useState<boolean>(false);
  const [username, setUsername] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [loginError, setLoginError] = useState<string>("");
    const [token, setToken] = useState(() => {
      try {
        const item: string = window.localStorage.getItem("token") as string;
        if (!item) return "";
        const decodedToken: any = jwtDecode(item);
        setUsername(decodedToken.aud);
        setEmail(decodedToken.sub);
        const currentTime = Date.now() / 1000; // Convert to seconds
        return (decodedToken.exp < currentTime) ? "" : item;
      } catch (error) {
        return "";
      }
    });

  const openLoginDialog = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setShowLoginDialog(true);
    setLoginError("");
  };

  const closeLoginDialog = () => {
    setShowLoginDialog(false);
    setLoading(false);
  };

  const handleLogin = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!email || !emailRegex.test(email)) {
      setLoginError("missing_email");
      return;
    }
    if (!password) {
      setLoginError("missing_password");
      return;
    }

    setLoading(true);
    setLoginError("");
    login(email, password)
      .then((res) => {
        const tokenValue = res.token;
        setToken(tokenValue);
        window.localStorage.setItem("token", tokenValue);
        const decodedToken: any = jwtDecode(tokenValue);
        setUsername(decodedToken.aud);
        setEmail(decodedToken.sub);
        setLoading(false);
        setShowLoginDialog(false);
      })
      .catch((err) => {
        if (err.response !== undefined && err.response.status === 401) {
          setLoginError("wrong_password");
        } else if (err.response !== undefined && err.response.status === 403) {
          setLoginError("not_verified");
        } else {
          setLoginError("network_error");
        }
        setLoading(false);
      });
  };

  // จำลองข้อมูลเกมจากรูปภาพเดิมเพื่อดึงมาแสดงผลใน Carousel 1 แถว
  const games = [
    { id: 1, name: "lethal_blade_title", image: '/img/lethal.jpg', url:'/main/lethalblade' },
    { id: 2, name: "thief_title", image: '/img/thief.jpg', url:'/main/thief' }
  ];

  // ตั้งค่าการทำงานของ Carousel (1 แถว / ปรับตามขนาดหน้าจอ)
  const carouselOptions = {
    type: 'loop',
    perPage: 2,
    gap: '1rem',
    autoplay: true,
    interval: 3000,
    pagination: false, // ปิดจุดไข่ปลาด้านล่างเพื่อให้สะอาดตาเหมือนหน้าเดิม
    arrows: true,      // เปิดลูกศรกดเลื่อนซ้าย-ขวา
    breakpoints: {
      1280: { perPage: 2 },
      1024: { perPage: 2 },
      768: { perPage: 2 },
      480: { perPage: 1 }
    }
  };

  const isMobile = () => {
    return window.innerWidth <= 480;
  };

     const handleLangChange = (value: string) => {
        setStoredLang(value);
        setLang(value);
      };
  
  useEffect(() => {    
    document.body.style.backgroundColor = "#223a44";
    document.body.style.color = "white";

    setLang(getInitialLang(window.location.search));
    return () => {
    };
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans selection:bg-cyan-500 selection:text-white">
      
      <div className="c" style={{width:"100%",paddingRight:"10px",paddingTop:"10px",overflowX: "hidden",position: "absolute", zIndex: 9999}}>
              <table><tbody><tr>
              <td width="80%"></td>
              <td width="220px" style={{textAlign: "right",whiteSpace: "nowrap",color: "white",fontSize: "14px"}}>
                {Lang.get(lang,"bandwidth")}&nbsp;&nbsp;
              </td>
              <td width="80px">
              <select value={resolution} className="form-select form-select-sm form-control-sm" onChange={e=>{setResolution(e.currentTarget.value)}} style={{width:"70px"}}>
                <option value="low" >{Lang.get(lang,"low")}</option>
                <option value="high" >{Lang.get(lang,"high")}</option>
              </select>
              </td>
              <td width="80px">
              <select value={lang} className="form-select form-select-sm form-control-sm" onChange={e=>{handleLangChange(e.currentTarget.value)}} style={{width:"70px"}}>
                <option value="th">ไทย</option>
                <option value="en">Eng</option>
              </select>
              </td>
              </tr></tbody></table>
      </div>

      {/* 2. MAIN CONTENT & CAROUSEL (แถวเกมสไลด์เดี่ยว) */}
      <main className="max-w-7xl mx-auto px-6 py-10">
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between mb-6" 
        style={{backgroundColor: "#223a44", color: "white", padding: "20px"}}>
            <div className="flex flex-wrap gap-1 menulink">
            <img src="/img/capture.png" alt="New Games" className="w-1 logo_main"/>
            { isMobile() &&
              <br/>
            }
              {token && (
                <>
                  <a href="/logout" className="rounded-full bg-cyan-500 px-1 py-1 text-sm font-semibold text-slate-950 transition hover:bg-cyan-400" onClick={() => {
                    setToken("");
                    window.localStorage.removeItem("token");
                  }}>
                    {Lang.get(lang,"logout")}
                  </a>
                  <a href="/changepassword" className="rounded-full bg-cyan-500 px-1 py-1 text-sm font-semibold text-slate-950 transition hover:bg-cyan-400">
                    {Lang.get(lang,"change_password")}
                  </a>
                  <span className="px-1 py-1 text-sm font-semibold"> {Lang.get(lang,"welcome")}:&nbsp;&nbsp;{username}</span>
                </>
              )}
              { !token && (
                <>
              <a href="/login" className="rounded-full bg-cyan-500 px-3 py-1 text-sm font-semibold text-slate-950 transition hover:bg-cyan-400 " onClick={openLoginDialog}>
                {Lang.get(lang,"login")}
              </a>
              <a href="/signup" className="rounded-full bg-cyan-500 px-3 py-1 text-sm font-semibold text-slate-950 transition hover:bg-cyan-400">
                {Lang.get(lang,"signup")}
               </a>
            <a href="/resetpassword" className="rounded-full bg-cyan-500 px-3 py-1 text-sm font-semibold text-slate-950 transition hover:bg-cyan-400">
              {Lang.get(lang,"forget_password")}
            </a>
              </>)
               }
      
            </div>
        </div>

        {/* เรียกใช้งาน React Splide สำหรับทำสไลด์เดี่ยวตามบรีฟ */}
        <div className="relative px-2">
          <Splide options={carouselOptions}>
            {games.map((game) => (
              <SplideSlide key={game.id} className="py-2">
                <div className="bg-[#1a2c38] border-2 border-[#00d2ff] rounded-xl overflow-hidden p-3 shadow-lg flex flex-col justify-between h-[310px] transition-transform duration-300 hover:-translate-y-1"
                  onClick={() => { window.location.href = game.url }} style={{cursor: "pointer"}}>
                  <img 
                    src={game.image} 
                    alt={game.name} 
                    className="w-full h-40 object-cover rounded-lg mb-3" 
                    style={{width:'100%' ,height:'400px'}}
                  />
                  <div className="flex flex-col justify-between flex-grow">
                    {Lang.get(lang, game.name)}
                  </div>
                </div>
              </SplideSlide>
            ))}
          </Splide>
        </div>
          <div style={{position: "absolute",left: "50%",transform: "translate(-50%, 0)",marginLeft:"0px",bottom:"10px",zIndex: 999,whiteSpace: "nowrap",fontSize: "14px"}}>
            { Lang.get(lang,"copyright_title")} { Lang.get(lang,"all_right_reserve_title")}
        </div>

      </main>

      {showLoginDialog && (
        <div style={{position:"absolute", left:"50%",top:"50%", transform:"translate(-50%, -50%)", zIndex: 9999}}>
          <div style={{ backgroundColor: '#223a44', borderRadius: '20px', padding: '20px', width: '350px', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)' }}>
            <div className="mb-4 flex items-center justify-between">
              <h4 className="text-md font-semibold">{Lang.get(lang, "login")}</h4>
              <button className="text-slate-300 hover:text-white" onClick={closeLoginDialog} style={{position: "absolute", top: "10px", right: "10px", fontSize: "18px"}}>
                ×
              </button>
            </div>
            <div className="space-y-4 text-center">
              <div>
                <label className="mb-2 block text-sm text-slate-200">{Lang.get(lang, "email")}</label><br/>
                <input
                  type="text"
                  className="w-full rounded-lg border border-slate-600 bg-slate-900 px-3 py-2 text-black outline-none focus:border-cyan-500"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                />
              </div>
              <div>
                <label className="mb-2 block text-sm text-slate-200">{Lang.get(lang, "password")}</label><br/>
                <input
                  type="password"
                  className="w-full rounded-lg border border-slate-600 bg-slate-900 px-3 py-2 text-black outline-none focus:border-cyan-500"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={loading}
                />
              </div>
              {loginError && (
                <div className="rounded-lg bg-red-600/20 px-3 py-2 text-sm text-red-100">
                  {Lang.get(lang, loginError)}
                </div>
              )}
              <br/>
              <div className="flex items-center justify-end gap-3">                
                <button
                  className="rounded-full bg-cyan-500 px-4 py-2 text-sm font-semibold text-slate-950 hover:bg-cyan-400"
                  onClick={handleLogin}
                  disabled={loading}
                  style={{width: "150px"}}
                >
                  {loading ? Lang.get(lang, "loading") || 'Loading...' : Lang.get(lang, "login")}
                </button>&nbsp;&nbsp;
                <button
                  className="rounded-full bg-slate-700 px-4 py-2 text-sm font-semibold text-slate-300 hover:bg-slate-600"
                  onClick={closeLoginDialog}
                  disabled={loading}
                  style={{width: "150px"}}
                >
                  {Lang.get(lang, "cancel_title") || 'Cancel'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}